import React, { useEffect } from 'react'
import Supplier from '../Editors/Supplier'
import { Route, useHistory, useParams } from 'react-router-dom';
import SupplierAircraftList from '../EntityList/SupplierAircraftList';
import SupplierDocumentList from '../EntityList/SupplierDocumentList';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { useEdit } from '../../Services/EditContext';
import BidHistory from '../EntityList/BidHistory';

import { useFormikContext } from 'formik';
import { SupplierMessageLog, ViewMessageLogModal } from '../EntityList/ViewMessageLog';
import TimeLine from '../EntityList/TimeLine';
import { useAuth } from '../../Services/AuthContext';

const EditSupplier = ({ route, isNewItem }) => {
    const { activeKey, supplierId } = useParams();
    const { values } = useFormikContext();
    let { push } = useHistory();
    const setActiveTab = (tab) => {

        if (push && supplierId && route) {
            push(route + '/' + supplierId + '/' + tab);
        }

    }
    useEffect(() => {
        if (push && !activeKey && supplierId && route) {
            push(route + '/' + supplierId + '/Detail');
        }
    }, [activeKey, push, route, supplierId])

    const [edit] = useEdit();
    const [auth] = useAuth();
    
    const isAdminOrSupplier=auth.role==='Admin'||auth.role==='Supplier';

    return <Tabs onSelect={setActiveTab} activeKey={activeKey} style={{ height: '100%' }}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            <Supplier invite={isNewItem} route={`${route}`} />
        </Tab>
        {!edit && <Tab key={'Aircraft'} eventKey={'Aircraft'} title='Aircraft' style={{ height: '400px' }} >
            {activeKey === 'Aircraft' ? <SupplierAircraftList route={route + '/' + supplierId + '/' + activeKey} parentHeight={400} supplierId={supplierId} headerHeight={0} /> : null}
        </Tab>
        }
        {!edit && <Tab key={'Documents'} eventKey={'Documents'} title='Documents' style={{ height: '400px' }} >
            {activeKey === 'Documents' ? <SupplierDocumentList route={route + '/' + supplierId + '/' + activeKey} parentHeight={400} headerHeight={0} /> : null}
        </Tab>
        }
        {!edit && isAdminOrSupplier && <Tab key={'Bids'} eventKey={'Bids'} title='Bids' style={{ height: '400px' }} >
            {activeKey === 'Bids' ? <BidHistory item={values} route={route + '/' + supplierId + '/' + activeKey} parentHeight={400} headerHeight={0} /> : null}
        </Tab>}
        {!edit && isAdminOrSupplier && <Tab key={'Messages'} eventKey={'Messages'} title='Messages' style={{ height: '400px' }} >
            {activeKey === 'Messages' ? <SupplierMessageLog supplierId={values?.id} item={values} route={route + '/' + supplierId + '/' + activeKey} parentHeight={400} headerHeight={0} /> : null}
            <Route path={route + '/' + supplierId + '/Messages/:messageId'} render={() => <ViewMessageLogModal />} />
        </Tab>
        }
        {!edit && isAdminOrSupplier && <Tab key={'Timeline'} eventKey={'Timeline'} title='Timeline' style={{ height: '400px' }} >
            {activeKey === 'Timeline' ? <TimeLine clientCol charterRequestCol type={"Supplier"} item={values} route={route + '/' + supplierId + "/Timeline"} parentHeight={400} headerHeight={0} /> : null}
        </Tab>
        }
    </Tabs >
}


export default EditSupplier;